import React from 'react';
import {
    renderRow, renderCopyTrigger, AnimatedTabs, Card, AdvancedTable,
} from 'components';
import { MappedExpertStatus } from 'components/enums';
import {
    IAttestationCommissionDetails,
    IAttestationSubCommissionsList,
    IBaseInfo,
} from 'components/models';
import { formatPhoneNumber } from '_helpers';
import { Tab } from 'react-bootstrap';
import { IAttestationSubCommissionsFilters } from '../reduxModels';
import { useMultiSearch } from 'hooks';
import { PaginationImpl } from '../defaultValues';

const AcDetailsInfo = ({ details, ascList, ...props }: IProps) => {
    const { filters, changeFilter } = useMultiSearch<IAttestationSubCommissionsFilters>(ascList.fetch, {
        acIds: [props.acId],
    });

    React.useEffect(() => {
        details.fetch(props.acId);
        ascList.fetch(filters);
        return () => {
            details.clear();
            ascList.clear();
        };
    }, [props.acId]);

    const infoRows = [];
    if (details.info) {
        infoRows.push(renderRow('РЕГИОН', renderCopyTrigger(details.info.regionName)));
        details.info.leaders.forEach((l) => {
            const status = l.linkedExpertStatuses.find(s => details.info && s.acId === details.info.id && s.ascId === null);
            const mappedStatus = MappedExpertStatus[status ? status.status : ''];
            return infoRows.push(
              renderRow(mappedStatus.text, `${l.lastName} ${l.firstName} ${l.middleName}`, 'mt-5'),
              renderRow('МЕСТО РАБОТЫ', l.placeOfWork),
              renderRow('ДОЛЖНОСТЬ', l.position),
              renderRow('ТЕЛЕФОН', formatPhoneNumber(l.phone) || ''),
              renderRow('ПОЧТА', l.email),
            );
        });
    }

    const ascTableHeader = [
        { fieldName: 'qualificationTitle', title: 'СПЕЦИАЛЬНОСТЬ' },
        { fieldName: 'chairmanFullName', title: 'ПРЕДСЕДАТЕЛЬ АПК' },
    ];

    const pagination = new PaginationImpl(ascList.info);
    return (
      <AnimatedTabs defaultActiveKey="info">
          <Tab title="Информация" eventKey="info">
              <Card
                withoutBorder
                title="Информация об АК"
                category="Общая информация об аккредитационной комиссии"
              >
                  {infoRows}
              </Card>
          </Tab>
          <Tab title="Список АПК" eventKey="asc">
              <Card
                withoutBorder
                withoutPadding
                title="Список АПК"
                category="Список всех аккредитационных подкомиссий"
              >
                  <AdvancedTable
                    data={ascList.info ? ascList.info.items.map(asc => ({
                        id: asc.id,
                        columns: [
                          asc.qualificationTitle,
                          asc.chairmanFullName || '-',
                        ],
                    })) : []}
                    tableHeaders={ascTableHeader}
                    handleRowClick={() => true}
                    page={pagination.page}
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    handlePageChange={p => changeFilter({
                        page: p.page,
                        pageSize: p.perPage,
                    })}
                    handleSearch={(f, t) => changeFilter({
                        searchTerm: t,
                        searchField: f,
                    })}
                    handleOrder={f => changeFilter({
                        sortField: f,
                        sortOrder: filters.sortField === f ? !filters.sortOrder : true,
                    })}
                  />
              </Card>
          </Tab>
      </AnimatedTabs>
    );
};

export default AcDetailsInfo;

interface IProps {
    acId: string;
    details: IBaseInfo<IAttestationCommissionDetails, string>;
    ascList: IBaseInfo<IAttestationSubCommissionsList, IAttestationSubCommissionsFilters>;
}
